export default function setIsAdjustingCenterline(isAdjustingCenterline) {
  return (notify, getSceneState) => {
    const sceneState = getSceneState();

    sceneState.isAdjustingCenterline = isAdjustingCenterline;

    notify();
  };
}
